import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { Sun, Moon, CheckCircle } from 'lucide-react';
import API from '../utils/api';

export default function Guidelines() {
  const navigate = useNavigate();
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/api/public/guidelines')
      .then(r => setContent(r.data.guidelines?.content || ''))
      .finally(() => setLoading(false));
  }, []);

  const checklist = [
    'No runtime limit — movies, series & shorts welcome',
    'Provide a shareable working link',
    'You must own all rights',
    'Subtitles for non-English films',
    'One submission per film',
  ];

  const handleCTA = () => {
    if (user) { navigate('/submit'); } else { navigate('/'); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <nav className="guidelines-navbar" style={{ borderBottom: '1.5px solid var(--border)', padding: '0 32px', height: 58, display: 'flex', alignItems: 'center', gap: 14, background: 'var(--nav-bg)', backdropFilter: 'blur(18px)', WebkitBackdropFilter: 'blur(18px)', position: 'sticky', top: 0, zIndex: 100 }}>
        <img src="/logo.png" alt="Shortflix" style={{ height: 28, cursor: 'pointer', flexShrink: 0 }} onClick={() => navigate(user ? '/dashboard' : '/')} onError={e => { e.target.style.display = 'none'; }} />
        <span className="guidelines-navbar-label" style={{ color: 'var(--border-strong)', fontSize: 18 }}>|</span>
        <span className="guidelines-navbar-label" style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>Submission Guidelines</span>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <button onClick={toggle} className="guidelines-navbar-theme-btn" style={{ width: 32, height: 32, borderRadius: 'var(--r-sm)', background: 'var(--bg-elevated)', border: '1.5px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
            {theme === 'dark' ? <Sun size={13} color="var(--text-secondary)" /> : <Moon size={13} color="var(--text-secondary)" />}
          </button>
          {user ? (
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => navigate('/dashboard')} className="guidelines-navbar-secondary-btn" style={{ background: 'var(--bg-elevated)', color: 'var(--text)', border: '1.5px solid var(--border)', borderRadius: 'var(--r-md)', padding: '7px 14px', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: 'var(--font)', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>My Dashboard</button>
              <button onClick={handleCTA} className="btn-primary guidelines-navbar-cta" style={{ padding: '7px 16px', fontSize: 11, whiteSpace: 'nowrap' }}>Submit a Film →</button>
            </div>
          ) : (
            <button onClick={handleCTA} className="btn-primary guidelines-navbar-cta" style={{ padding: '7px 16px', fontSize: 11, whiteSpace: 'nowrap' }}>Sign In to Submit →</button>
          )}
        </div>
      </nav>
      <div className="guidelines-grid">
        <div>
          <div style={{ fontSize: 10, fontWeight: 800, color: 'var(--pink)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12 }}>Guidelines</div>
          <h1 style={{ fontWeight: 900, fontSize: 38, color: 'var(--text)', marginBottom: 6, letterSpacing: '-0.02em' }}>Submission Guidelines</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 36, fontWeight: 400 }}>Please read carefully before submitting your film.</p>
          {loading ? (
            <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>Loading guidelines...</div>
          ) : (
            <div style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.8, fontWeight: 400 }}>
              {content.split('\n\n').map((p, i) => <p key={i} style={{ marginBottom: 16 }}>{p}</p>)}
            </div>
          )}
        </div>
        <div style={{ position: 'sticky', top: 80, height: 'fit-content' }}>
          <div className="card" style={{ padding: 22 }}>
            <div className="section-label" style={{ marginBottom: 14 }}>Quick Checklist</div>
            {checklist.map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 11, fontSize: 12, color: 'var(--text-secondary)', fontWeight: 500 }}>
                <CheckCircle size={13} color="var(--green)" style={{ flexShrink: 0, marginTop: 1 }} />{item}
              </div>
            ))}
            <hr className="divider" style={{ margin: '14px 0' }} />
            <button onClick={handleCTA} className="btn-primary" style={{ width: '100%' }}>
              {user ? 'Submit Your Film →' : 'Sign In to Submit →'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
